import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { trackWhatsAppClick } from './MetaPixel';
export function FinalCTA() {
  return <section className="relative py-32 md:py-48 flex items-center justify-center overflow-hidden" data-id="element-137" data-mp="c6sjteywm4bs">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-138" data-mp="84xjacosruz2">
        <img src="https://cdn.magicpatterns.com/uploads/3uxr8pkgt9rQrSsRewzUAF/ChatGPT_Image_18_may_2026,_10_15_58.png" alt="Amanecer esperanza" className="w-full h-full object-cover object-center" data-id="element-139" data-mp="879zolewpxa0" />
        <div className="absolute inset-0 bg-ink/80" data-id="element-140" data-mp="vv9p9i0hfhn0"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-ink/50" data-id="element-141" data-mp="vwukl9umf4lx"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 text-center" data-id="element-142" data-mp="qy15xe3ll7k6">
        <motion.div className="max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-143" data-mp="14vzlgmtnna19">
          <span className="text-gold tracking-[0.2em] text-xs md:text-sm font-semibold uppercase mb-6 block" data-id="element-144" data-mp="2m21d0w4omm1w">
            ¿QUÉ HAGO AHORA?
          </span>
          <h2 className="text-5xl md:text-7xl font-serif text-ivory-bright mb-10 leading-tight" data-id="element-145" data-mp="2v3sfls3xecrj">
            NO TIENES QUE TENER TODAS LAS RESPUESTAS HOY.
          </h2>

          <div className="space-y-6 text-lg text-ivory/90 font-light mb-12" data-id="element-146" data-mp="300itq9w66yab">
            <p className="font-serif text-2xl md:text-3xl italic text-gold" data-id="element-147" data-mp="34tu6ernny9a5">
              Solo necesitas estar dispuesto a comenzar.
            </p>
            <p data-id="element-148" data-mp="3errtvcxp821p">
              Tal vez no puedas cambiar lo que ocurrió. Pero sí puedes decidir qué haces a partir de ahora.
            </p>
            <p data-id="element-149" data-mp="3itwlk64l6olp">
              Tu nuevo punto de partida puede comenzar con una decisión.
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-150" data-mp="1jolba6xtm789">
            <a href="https://wa.me/5491145263003" target="_blank" rel="noopener noreferrer" onClick={trackWhatsAppClick} className="inline-flex items-center justify-center gap-3 px-10 py-5 bg-[#25D366] text-white hover:bg-[#1DA851] transition-all duration-300 font-medium tracking-wide group text-lg shadow-xl shadow-[#25D366]/25 rounded-xl" data-id="element-151" data-mp="1npyjuosasoiv">
              <MessageCircle className="w-6 h-6 group-hover:scale-110 transition-transform" data-id="element-152" data-mp="27do48axwnmi2" />
              QUIERO RECUPERAR MI VIDA
            </a>
            <p className="mt-6 text-sm text-muted flex items-center justify-center gap-2" data-id="element-153" data-mp="h3kud7xyutxb">
              Primera edición · 10 lugares disponibles · USD 30
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}